// Demo data for the application

// Demo user
export const demoUser = {
  id: 'demo-user-id',
  walletAddress: '0x742d35Cc6634C0532925a3b844Bc454e4438f44e',
  username: 'DemoUser',
  email: 'demo@fttf.world',
  registeredAt: new Date().toISOString(),
  isCreator: true,
  isAdmin: false,
  balance: '1000.00',
  profileImage: 'https://images.unsplash.com/photo-1633332755192-727a05c4013d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1180&q=80',
  isVerified: true,
};

// Demo creators
export const demoCreators = [
  {
    id: 'creator-1',
    name: 'Alex Rivers',
    username: 'ArtistOne',
    walletAddress: '0x1234567890abcdef1234567890abcdef12345678',
    bio: 'Digital artist specializing in abstract and surreal art. Creating NFTs since 2021. Exploring the boundaries between reality and imagination through digital mediums.',
    profileImageUrl: 'https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1180&q=80',
    coverImageUrl: 'https://images.unsplash.com/photo-1579546929518-9e396f3cc809?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80',
    nftCount: 15,
    streamCount: 12,
    followers: 1200,
    following: 350,
    joinedDate: '2023-01-15',
    socialLinks: {
      twitter: 'https://twitter.com/artistone',
      instagram: 'https://instagram.com/artistone',
      website: 'https://artistone.io'
    },
    verified: true,
    featured: true
  },
  {
    id: 'creator-2',
    name: 'Maya Johnson',
    username: 'MusicProducer',
    walletAddress: '0x2345678901abcdef2345678901abcdef23456789',
    bio: 'Electronic music producer and sound designer. Creating audio NFTs and live performances. Blending traditional instruments with digital production to create unique soundscapes.',
    profileImageUrl: 'https://images.unsplash.com/photo-1570295999919-56ceb5ecca61?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1180&q=80',
    coverImageUrl: 'https://images.unsplash.com/photo-1614624532983-4ce03382d63d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1331&q=80',
    nftCount: 8,
    streamCount: 24,
    followers: 850,
    following: 210,
    joinedDate: '2023-03-22',
    socialLinks: {
      twitter: 'https://twitter.com/musicproducer',
      soundcloud: 'https://soundcloud.com/musicproducer',
      website: 'https://musicproducer.fm'
    },
    verified: true,
    featured: false
  },
  {
    id: 'creator-3',
    name: 'Ethan Wright',
    username: 'CryptoArtist',
    walletAddress: '0x3456789012abcdef3456789012abcdef34567890',
    bio: 'Crypto-native artist exploring the intersection of blockchain and creativity. My work examines how decentralized technologies are reshaping our understanding of ownership and value in the digital age.',
    profileImageUrl: 'https://images.unsplash.com/photo-1633332755192-727a05c4013d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1180&q=80',
    coverImageUrl: 'https://images.unsplash.com/photo-1620641788421-7a1c342ea42e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1074&q=80',
    nftCount: 22,
    streamCount: 5,
    followers: 1500,
    following: 120,
    joinedDate: '2022-11-05',
    socialLinks: {
      twitter: 'https://twitter.com/cryptoartist',
      instagram: 'https://instagram.com/cryptoartist',
      foundation: 'https://foundation.app/@cryptoartist'
    },
    verified: true,
    featured: true
  },
  {
    id: 'creator-4',
    name: 'Sophia Chen',
    username: 'VRArtist',
    walletAddress: '0x4567890123abcdef4567890123abcdef45678901',
    bio: 'Virtual reality artist creating immersive digital experiences and NFT collectibles. Pushing the boundaries of what is possible in virtual spaces and exploring new forms of digital interaction.',
    profileImageUrl: 'https://images.unsplash.com/photo-1527980965255-d3b416303d12?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1180&q=80',
    coverImageUrl: 'https://images.unsplash.com/photo-1634017839464-5c339ebe3cb4?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1035&q=80',
    nftCount: 12,
    streamCount: 10,
    followers: 950,
    following: 280,
    joinedDate: '2023-05-18',
    socialLinks: {
      twitter: 'https://twitter.com/vrartist',
      instagram: 'https://instagram.com/vrartist',
      website: 'https://vrartist.world'
    },
    verified: false,
    featured: true
  }
];

// Demo streams
export const demoStreams = [
  {
    id: 'demo-stream-1',
    creatorId: 'creator-1',
    creatorName: demoCreators[0].username,
    creatorAddress: demoCreators[0].walletAddress,
    creatorImageUrl: demoCreators[0].profileImageUrl,
    title: 'Introduction to Web3 Development',
    description: 'Learn the basics of Web3 development with this comprehensive tutorial stream. We will cover smart contracts, dApps, and how to integrate with popular blockchain networks.',
    playbackId: '6d7el73r1y12chxr',
    streamKey: 'demo-stream-key-1',
    startTime: new Date(Date.now() - 3600000).toISOString(),
    endTime: null,
    recordingUrl: 'https://livepeercdn.com/recordings/6d7el73r1y12chxr/index.m3u8',
    isActive: true,
    isLive: true,
    createdAt: new Date(Date.now() - 3600000).toISOString(),
    updatedAt: new Date(Date.now() - 3600000).toISOString(),
    thumbnailUrl: 'https://images.unsplash.com/photo-1633356122544-f134324a6cee?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80',
    viewCount: 1245,
    likeCount: 342,
    commentCount: 87,
    tags: ['web3', 'development', 'blockchain', 'tutorial'],
    category: 'Technology',
    isTokenGated: false,
    creator: {
      id: 'creator-1',
      username: demoCreators[0].username,
      walletAddress: demoCreators[0].walletAddress,
      avatarUrl: demoCreators[0].profileImageUrl,
      isVerified: demoCreators[0].verified,
    },
  },
  {
    id: 'demo-stream-2',
    creatorId: 'creator-1',
    creatorName: demoCreators[0].username,
    creatorAddress: demoCreators[0].walletAddress,
    creatorImageUrl: demoCreators[0].profileImageUrl,
    title: 'NFT Creation Workshop',
    description: 'Join us for a hands-on workshop on creating and minting your own NFTs. Learn about metadata, IPFS, and best practices for digital art creation.',
    playbackId: '8f9gm84s2z23diys',
    streamKey: 'demo-stream-key-2',
    startTime: new Date(Date.now() - 86400000).toISOString(),
    endTime: new Date(Date.now() - 79200000).toISOString(),
    recordingUrl: 'https://livepeercdn.com/recordings/8f9gm84s2z23diys/index.m3u8',
    isActive: false,
    isLive: false,
    createdAt: new Date(Date.now() - 86400000).toISOString(),
    updatedAt: new Date(Date.now() - 86400000).toISOString(),
    thumbnailUrl: 'https://images.unsplash.com/photo-1620641788421-7a1c342ea42e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1074&q=80',
    viewCount: 876,
    likeCount: 231,
    commentCount: 45,
    tags: ['nft', 'art', 'crypto', 'workshop'],
    category: 'Art',
    isTokenGated: false,
    creator: {
      id: 'creator-1',
      username: demoCreators[0].username,
      walletAddress: demoCreators[0].walletAddress,
      avatarUrl: demoCreators[0].profileImageUrl,
      isVerified: demoCreators[0].verified,
    },
  },
  {
    id: 'demo-stream-3',
    creatorId: 'creator-3',
    creatorName: demoCreators[2].username,
    creatorAddress: demoCreators[2].walletAddress,
    creatorImageUrl: demoCreators[2].profileImageUrl,
    title: 'Blockchain Gaming Future',
    description: 'Exploring the future of gaming on blockchain platforms. We will discuss play-to-earn models, in-game assets as NFTs, and the metaverse.',
    playbackId: '3k2lp95t3a34ejzt',
    streamKey: 'demo-stream-key-3',
    startTime: new Date(Date.now() - 172800000).toISOString(),
    endTime: new Date(Date.now() - 165600000).toISOString(),
    recordingUrl: 'https://livepeercdn.com/recordings/3k2lp95t3a34ejzt/index.m3u8',
    isActive: false,
    isLive: false,
    createdAt: new Date(Date.now() - 172800000).toISOString(),
    updatedAt: new Date(Date.now() - 172800000).toISOString(),
    thumbnailUrl: 'https://images.unsplash.com/photo-1614680376573-df3480f0c6ff?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1074&q=80',
    viewCount: 543,
    likeCount: 128,
    commentCount: 32,
    tags: ['gaming', 'blockchain', 'metaverse', 'play-to-earn'],
    category: 'Gaming',
    isTokenGated: false,
    creator: {
      id: 'creator-3',
      username: demoCreators[2].username,
      walletAddress: demoCreators[2].walletAddress,
      avatarUrl: demoCreators[2].profileImageUrl,
      isVerified: demoCreators[2].verified,
    },
  },
  {
    id: 'demo-stream-4',
    creatorId: 'creator-2',
    creatorName: demoCreators[1].username,
    creatorAddress: demoCreators[1].walletAddress,
    creatorImageUrl: demoCreators[1].profileImageUrl,
    title: 'Live Music Production Session',
    description: 'Watch me produce a new track from scratch. I will be showing my workflow and techniques for electronic music production.',
    playbackId: '4m3np06u4b45fkau',
    streamKey: 'demo-stream-key-4',
    startTime: new Date(Date.now() - 259200000).toISOString(),
    endTime: new Date(Date.now() - 252000000).toISOString(),
    recordingUrl: 'https://livepeercdn.com/recordings/4m3np06u4b45fkau/index.m3u8',
    isActive: false,
    isLive: false,
    createdAt: new Date(Date.now() - 259200000).toISOString(),
    updatedAt: new Date(Date.now() - 259200000).toISOString(),
    thumbnailUrl: 'https://images.unsplash.com/photo-1598488035139-bdbb2231ce04?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80',
    viewCount: 721,
    likeCount: 189,
    commentCount: 56,
    tags: ['music', 'production', 'electronic', 'live'],
    category: 'Music',
    isTokenGated: true,
    tokenGateInfo: {
      type: 'token',
      tokenAmount: '50',
      tokenSymbol: 'FTTF',
      price: '5',
      currency: 'DUSD'
    },
    creator: {
      id: 'creator-2',
      username: demoCreators[1].username,
      walletAddress: demoCreators[1].walletAddress,
      avatarUrl: demoCreators[1].profileImageUrl,
      isVerified: demoCreators[1].verified,
    },
  },
  {
    id: 'demo-stream-5',
    creatorId: 'creator-4',
    creatorName: demoCreators[3].username,
    creatorAddress: demoCreators[3].walletAddress,
    creatorImageUrl: demoCreators[3].profileImageUrl,
    title: 'Virtual Reality Art Creation',
    description: 'Join me as I create 3D art in virtual reality. I will be demonstrating techniques for sculpting and painting in VR.',
    playbackId: '5n4oq17v5c56glbv',
    streamKey: 'demo-stream-key-5',
    startTime: new Date(Date.now() - 345600000).toISOString(),
    endTime: new Date(Date.now() - 338400000).toISOString(),
    recordingUrl: 'https://livepeercdn.com/recordings/5n4oq17v5c56glbv/index.m3u8',
    isActive: false,
    isLive: false,
    createdAt: new Date(Date.now() - 345600000).toISOString(),
    updatedAt: new Date(Date.now() - 345600000).toISOString(),
    thumbnailUrl: 'https://images.unsplash.com/photo-1626379953822-baec19c3accd?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80',
    viewCount: 632,
    likeCount: 154,
    commentCount: 41,
    tags: ['vr', 'art', '3d', 'digital-art'],
    category: 'Art',
    isTokenGated: false,
    creator: {
      id: 'creator-4',
      username: demoCreators[3].username,
      walletAddress: demoCreators[3].walletAddress,
      avatarUrl: demoCreators[3].profileImageUrl,
      isVerified: demoCreators[3].verified,
    },
  },
];

// Demo drops (NFT collections)
export const demoDrops = [
  {
    id: 'demo-drop-1',
    creatorId: 'creator-1',
    creatorName: demoCreators[0].username,
    creatorAddress: demoCreators[0].walletAddress,
    title: 'Digital Art Collection 2025',
    description: 'A collection of unique digital art pieces created exclusively for FTTF.World.',
    ipfsCid: 'QmXyZ123456789abcdef123456789abcdef123456',
    isTokenGated: false,
    startTime: new Date(Date.now() - 604800000).toISOString(),
    endTime: new Date(Date.now() + 604800000).toISOString(),
    createdAt: new Date(Date.now() - 604800000).toISOString(),
    updatedAt: new Date(Date.now() - 604800000).toISOString(),
    isActive: true,
    thumbnailUrl: 'https://images.unsplash.com/photo-1579546929518-9e396f3cc809?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80',
    coverImageUrl: 'https://images.unsplash.com/photo-1620641788421-7a1c342ea42e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1074&q=80',
    itemCount: 10,
    totalSales: '15.5',
    creator: {
      id: 'creator-1',
      username: demoCreators[0].username,
      walletAddress: demoCreators[0].walletAddress,
      avatarUrl: demoCreators[0].profileImageUrl,
      isVerified: demoCreators[0].verified,
    },
  },
  {
    id: 'demo-drop-2',
    creatorId: 'creator-2',
    creatorName: demoCreators[1].username,
    creatorAddress: demoCreators[1].walletAddress,
    title: 'Abstract Soundscapes Collection',
    description: 'A collection of audio NFTs exploring experimental soundscapes.',
    ipfsCid: 'QmYxZ987654321abcdef987654321abcdef987654',
    isTokenGated: true,
    tokenGateAmount: '10',
    startTime: new Date(Date.now() - 86400000).toISOString(),
    endTime: new Date(Date.now() + 86400000).toISOString(),
    createdAt: new Date(Date.now() - 86400000).toISOString(),
    updatedAt: new Date(Date.now() - 86400000).toISOString(),
    isActive: true,
    thumbnailUrl: 'https://images.unsplash.com/photo-1614680376573-df3480f0c6ff?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1074&q=80',
    coverImageUrl: 'https://images.unsplash.com/photo-1598488035139-bdbb2231ce04?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80',
    itemCount: 5,
    totalSales: '8.2',
    creator: {
      id: 'creator-2',
      username: demoCreators[1].username,
      walletAddress: demoCreators[1].walletAddress,
      avatarUrl: demoCreators[1].profileImageUrl,
      isVerified: demoCreators[1].verified,
    },
  },
  {
    id: 'demo-drop-3',
    creatorId: 'creator-3',
    creatorName: 'CryptoArtist',
    creatorAddress: '0x3456789012abcdef3456789012abcdef34567890',
    title: 'Blockchain Visions',
    description: 'A collection of artworks inspired by blockchain technology and its impact on society.',
    ipfsCid: 'QmDef123456789abcdef123456789abcdef123456',
    isTokenGated: false,
    startTime: new Date(Date.now() - 2419200000).toISOString(),
    endTime: new Date(Date.now() + 2419200000).toISOString(),
    createdAt: new Date(Date.now() - 2419200000).toISOString(),
    updatedAt: new Date(Date.now() - 2419200000).toISOString(),
    isActive: true,
    thumbnailUrl: 'https://images.unsplash.com/photo-1620641788421-7a1c342ea42e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1074&q=80',
    coverImageUrl: 'https://images.unsplash.com/photo-1620641788421-7a1c342ea42e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1074&q=80',
    itemCount: 8,
    totalSales: '12.3',
    creator: {
      id: 'creator-3',
      username: demoCreators[2].username,
      walletAddress: demoCreators[2].walletAddress,
      avatarUrl: demoCreators[2].profileImageUrl,
      isVerified: demoCreators[2].verified,
    },
  },
  {
    id: 'demo-drop-4',
    creatorId: 'creator-4',
    creatorName: demoCreators[3].username,
    creatorAddress: demoCreators[3].walletAddress,
    title: 'Virtual Reality Experiences',
    description: 'Immersive VR experiences captured as NFTs. Each piece represents a unique virtual world.',
    ipfsCid: 'QmGhi123456789abcdef123456789abcdef123456',
    isTokenGated: true,
    gateTokenAddress: '0x2345678901abcdef2345678901abcdef23456789',
    startTime: new Date(Date.now() - 3628800000).toISOString(),
    endTime: new Date(Date.now() + 3628800000).toISOString(),
    createdAt: new Date(Date.now() - 3628800000).toISOString(),
    updatedAt: new Date(Date.now() - 3628800000).toISOString(),
    isActive: true,
    thumbnailUrl: 'https://images.unsplash.com/photo-1626379953822-baec19c3accd?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80',
    coverImageUrl: 'https://images.unsplash.com/photo-1626379953822-baec19c3accd?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80',
    itemCount: 6,
    totalSales: '9.7',
    creator: {
      id: 'creator-4',
      username: demoCreators[3].username,
      walletAddress: demoCreators[3].walletAddress,
      avatarUrl: demoCreators[3].profileImageUrl,
      isVerified: demoCreators[3].verified,
    },
  },
  {
    id: 'demo-drop-5',
    creatorId: 'creator-2',
    creatorName: 'MusicProducer',
    creatorAddress: '0x2345678901abcdef2345678901abcdef23456789',
    title: 'Audio NFT Collection',
    description: 'A collection of unique audio tracks and sound experiences available as NFTs.',
    ipfsCid: 'QmJkl123456789abcdef123456789abcdef123456',
    isTokenGated: false,
    startTime: new Date(Date.now() - 4838400000).toISOString(),
    endTime: new Date(Date.now() + 4838400000).toISOString(),
    createdAt: new Date(Date.now() - 4838400000).toISOString(),
    updatedAt: new Date(Date.now() - 4838400000).toISOString(),
    isActive: true,
    thumbnailUrl: 'https://images.unsplash.com/photo-1598488035139-bdbb2231ce04?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80',
    coverImageUrl: 'https://images.unsplash.com/photo-1598488035139-bdbb2231ce04?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80',
    itemCount: 12,
    totalSales: '18.5',
    creator: {
      id: 'creator-2',
      username: demoCreators[1].username,
      walletAddress: demoCreators[1].walletAddress,
      avatarUrl: demoCreators[1].profileImageUrl,
      isVerified: demoCreators[1].verified,
    },
  },
  {
    id: 'demo-drop-6',
    creatorId: demoUser.id,
    creatorName: demoUser.username,
    creatorAddress: demoUser.walletAddress,
    title: 'Futuristic Cityscapes',
    description: 'A collection of digital art depicting futuristic city environments and urban landscapes.',
    ipfsCid: 'QmMno123456789abcdef123456789abcdef123456',
    isTokenGated: false,
    startTime: new Date(Date.now() - 6048000000).toISOString(),
    endTime: new Date(Date.now() + 6048000000).toISOString(),
    createdAt: new Date(Date.now() - 6048000000).toISOString(),
    updatedAt: new Date(Date.now() - 6048000000).toISOString(),
    isActive: true,
    thumbnailUrl: 'https://images.unsplash.com/photo-1493246507139-91e8fad9978e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80',
    coverImageUrl: 'https://images.unsplash.com/photo-1493246507139-91e8fad9978e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80',
    itemCount: 15,
    totalSales: '22.8',
    creator: {
      id: demoUser.id,
      username: demoUser.username,
      walletAddress: demoUser.walletAddress,
      avatarUrl: demoUser.profileImage,
      isVerified: demoUser.isVerified,
    },
  }
];

// Demo NFTs
export const demoNfts = [
  {
    id: 'nft-1',
    tokenId: '1',
    contractAddress: '0xAbC123...',
    creatorId: 'creator-3',
    ownerId: demoUser.id,
    title: 'Abstract Vision',
    description: 'A unique abstract piece exploring the interplay of color and form.',
    ipfsCid: 'Qm...NFT1Cid',
    imageUrl: 'https://images.unsplash.com/photo-1579546929518-9e396f3cc809?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80',
    price: '0.1',
    currency: 'ETH',
    isForSale: true,
    royaltyPercentage: 10,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
    tokenType: 'ERC721',
    metadata: {
      name: 'Abstract Vision',
      description: 'A unique abstract piece exploring the interplay of color and form.',
      image: 'https://images.unsplash.com/photo-1579546929518-9e396f3cc809?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80',
      attributes: [
        { trait_type: 'Style', value: 'Abstract' },
        { trait_type: 'Color Palette', value: 'Vibrant' },
      ],
    },
    creator: {
      id: 'creator-3',
      username: demoCreators[2].username,
      walletAddress: demoCreators[2].walletAddress,
      avatarUrl: demoCreators[2].profileImageUrl,
      isVerified: demoCreators[2].verified,
    },
    owner: {
      id: demoUser.id,
      username: demoUser.username,
      walletAddress: demoUser.walletAddress,
      avatarUrl: demoUser.profileImage,
      isVerified: demoUser.isVerified,
    },
  },
  {
    id: 'nft-2',
    tokenId: '2',
    contractAddress: '0xDeF456...',
    creatorId: 'creator-1',
    ownerId: 'creator-2',
    title: 'Surreal Landscape',
    description: 'A dreamy landscape from another dimension.',
    ipfsCid: 'Qm...NFT2Cid',
    imageUrl: 'https://images.unsplash.com/photo-1620641788421-7a1c342ea42e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1074&q=80',
    price: '0.5',
    currency: 'ETH',
    isForSale: false,
    royaltyPercentage: 15,
    createdAt: new Date(Date.now() - 86400000).toISOString(),
    updatedAt: new Date(Date.now() - 86400000).toISOString(),
    tokenType: 'ERC721',
    metadata: {
      name: 'Surreal Landscape',
      description: 'A dreamy landscape from another dimension.',
      image: 'https://images.unsplash.com/photo-1620641788421-7a1c342ea42e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1074&q=80',
      attributes: [
        { trait_type: 'Genre', value: 'Surrealism' },
        { trait_type: 'Mood', value: 'Dreamy' },
      ],
    },
    creator: {
      id: 'creator-1',
      username: demoCreators[0].username,
      walletAddress: demoCreators[0].walletAddress,
      avatarUrl: demoCreators[0].profileImageUrl,
      isVerified: demoCreators[0].verified,
    },
    owner: {
      id: 'creator-2',
      username: demoCreators[1].username,
      walletAddress: demoCreators[1].walletAddress,
      avatarUrl: demoCreators[1].profileImageUrl,
      isVerified: demoCreators[1].verified,
    },
  },
  {
    id: 'nft-3',
    tokenId: '10',
    contractAddress: '0xGhI789...',
    creatorId: 'creator-4',
    ownerId: demoUser.id,
    title: 'Genesis Edition #1',
    description: 'The first edition in the Genesis series.',
    ipfsCid: 'Qm...NFT3Cid',
    imageUrl: 'https://images.unsplash.com/photo-1634017839464-5c339ebe3cb4?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1035&q=80',
    price: '0.05',
    currency: 'ETH',
    isForSale: true,
    royaltyPercentage: 5,
    createdAt: new Date(Date.now() - 172800000).toISOString(),
    updatedAt: new Date(Date.now() - 172800000).toISOString(),
    tokenType: 'ERC1155',
    metadata: {
      name: 'Genesis Edition #1',
      description: 'The first edition in the Genesis series.',
      image: 'https://images.unsplash.com/photo-1634017839464-5c339ebe3cb4?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1035&q=80',
      attributes: [
        { trait_type: 'Series', value: 'Genesis' },
        { trait_type: 'Edition', value: 1 },
      ],
    },
    creator: {
      id: 'creator-4',
      username: demoCreators[3].username,
      walletAddress: demoCreators[3].walletAddress,
      avatarUrl: demoCreators[3].profileImageUrl,
      isVerified: demoCreators[3].verified,
    },
    owner: {
      id: demoUser.id,
      username: demoUser.username,
      walletAddress: demoUser.walletAddress,
      avatarUrl: demoUser.profileImage,
      isVerified: demoUser.isVerified,
    },
  },
];

// Demo comments
export const demoComments = [
  {
    id: 'comment-1',
    userId: demoUser.id,
    contentId: 'demo-stream-1',
    contentType: 'stream',
    text: 'Great stream, very informative!',
    createdAt: new Date(Date.now() - 1800000).toISOString(),
    user: {
      id: demoUser.id,
      username: demoUser.username,
      walletAddress: demoUser.walletAddress,
      avatarUrl: demoUser.profileImage,
      isVerified: demoUser.isVerified,
    },
  },
  {
    id: 'comment-2',
    userId: 'creator-1',
    contentId: 'demo-nft-1',
    contentType: 'nft',
    text: 'Love this piece!',
    createdAt: new Date(Date.now() - 2400000).toISOString(),
    user: {
      id: 'creator-1',
      username: demoCreators[0].username,
      walletAddress: demoCreators[0].walletAddress,
      avatarUrl: demoCreators[0].profileImageUrl,
      isVerified: demoCreators[0].verified,
    },
  },
];

// Demo transactions
export const demoTransactions = [
  {
    id: 'tx-1',
    txHash: '0xabcdef123456...',
    fromAddress: demoUser.walletAddress,
    toAddress: 'creator-3-address',
    amount: '0.1',
    currency: 'ETH',
    type: 'purchase',
    status: 'completed',
    contentId: 'demo-nft-1',
    contentType: 'nft',
    createdAt: new Date(Date.now() - 10800000).toISOString(),
    updatedAt: new Date(Date.now() - 10800000).toISOString(),
  },
];

// Demo marketplace listings
export const demoMarketplace = [
  {
    id: 'demo-listing-1',
    nftId: 'demo-nft-1',
    sellerId: demoUser.id,
    sellerAddress: demoUser.walletAddress,
    price: '0.5',
    currency: 'DUSD',
    listedAt: new Date(Date.now() - 432000000).toISOString(),
    expiresAt: new Date(Date.now() + 432000000).toISOString(),
    status: 'active',
    nft: demoNfts[0],
  },
  {
    id: 'demo-listing-2',
    nftId: 'demo-nft-2',
    sellerId: 'other-user-id',
    sellerAddress: '0xabcdef123456789abcdef123456789abcdef1234',
    price: '0.3',
    currency: 'DUSD',
    listedAt: new Date(Date.now() - 345600000).toISOString(),
    expiresAt: new Date(Date.now() + 345600000).toISOString(),
    status: 'active',
    nft: demoNfts[1],
  },
];

// Demo sales history
export const demoSales = [
  {
    id: 'demo-sale-1',
    nftId: 'demo-nft-3',
    sellerId: 'other-user-id',
    sellerAddress: '0xabcdef123456789abcdef123456789abcdef1234',
    buyerId: demoUser.id,
    buyerAddress: demoUser.walletAddress,
    price: '0.8',
    currency: 'DUSD',
    transactionHash: '0x123456789abcdef123456789abcdef123456789abcdef123456789abcdef1234',
    timestamp: new Date(Date.now() - 604800000).toISOString(),
    platformFee: '0.02',
    royaltyFee: '0.08',
    nft: demoNfts[2],
  },
];

// Demo tips
export const demoTips = [
  {
    id: 'demo-tip-1',
    fromUserId: 'other-user-id',
    fromUserAddress: '0xabcdef123456789abcdef123456789abcdef1234',
    fromUsername: 'SupporterOne',
    toUserId: demoUser.id,
    toUserAddress: demoUser.walletAddress,
    toUsername: demoUser.username,
    amount: '50',
    currency: 'DUSD',
    transactionHash: '0xabcdef123456789abcdef123456789abcdef123456789abcdef123456789abcd',
    timestamp: new Date(Date.now() - 86400000).toISOString(),
    message: 'Great content! Keep it up!',
  },
  {
    id: 'demo-tip-2',
    fromUserId: demoUser.id,
    fromUserAddress: demoUser.walletAddress,
    fromUsername: demoUser.username,
    toUserId: 'other-user-id',
    toUserAddress: '0xabcdef123456789abcdef123456789abcdef1234',
    toUsername: 'ArtistOne',
    amount: '20',
    currency: 'DUSD',
    transactionHash: '0x987654321fedcba987654321fedcba987654321fedcba987654321fedcba9876',
    timestamp: new Date(Date.now() - 172800000).toISOString(),
    message: 'Amazing artwork!',
  },
];

// Demo governance proposals
export const demoProposals = [
  {
    id: '1',
    title: 'FTTF-1: Increase Creator Royalties to 15%',
    description: 'This proposal aims to increase the default creator royalties from 10% to 15% to better support content creators on the platform. Higher royalties will incentivize more high-quality content creation and attract top talent to the platform.',
    summary: 'Increase default creator royalties from 10% to 15%',
    proposer: '0x742d35Cc6634C0532925a3b844Bc454e4438f44e',
    proposerName: 'DemoUser',
    proposerAvatar: 'https://images.unsplash.com/photo-1633332755192-727a05c4013d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1180&q=80',
    startBlock: 12345678,
    endBlock: 12445678,
    startTime: new Date(Date.now() - 604800000).toISOString(),
    endTime: new Date(Date.now() + 604800000).toISOString(),
    status: 'active',
    forVotes: '1500000000000000000000',
    againstVotes: '500000000000000000000',
    abstainVotes: '100000000000000000000',
    quorum: '2000000000000000000000',
    totalVotes: '2100000000000000000000',
    forPercentage: 71.4,
    againstPercentage: 23.8,
    abstainPercentage: 4.8,
    createdAt: new Date(Date.now() - 604800000).toISOString(),
    category: 'Protocol',
    tags: ['Royalties', 'Creators', 'Revenue'],
    discussion: 'https://forum.fttf.world/t/proposal-increase-creator-royalties-to-15/123',
    actions: [
      {
        target: '0x609310f1014A6f3A26243C26B3027C86B7f5776f',
        value: '0',
        signature: 'setDefaultRoyalty(uint256)',
        calldata: '0x000000000000000000000000000000000000000000000000000000000000000f',
        description: 'Set default royalty to 15%',
      },
    ],
    voters: [
      {
        address: '0x742d35Cc6634C0532925a3b844Bc454e4438f44e',
        name: 'DemoUser',
        vote: 'for',
        power: '500000000000000000000',
        timestamp: new Date(Date.now() - 500000000).toISOString(),
      },
      {
        address: '0xabcdef123456789abcdef123456789abcdef1234',
        name: 'MusicCreator',
        vote: 'for',
        power: '1000000000000000000000',
        timestamp: new Date(Date.now() - 400000000).toISOString(),
      },
      {
        address: '0x123456789abcdef123456789abcdef123456789a',
        name: 'NFTCollector',
        vote: 'against',
        power: '500000000000000000000',
        timestamp: new Date(Date.now() - 300000000).toISOString(),
      },
      {
        address: '0x987654321fedcba987654321fedcba987654321f',
        name: 'CryptoWhale',
        vote: 'abstain',
        power: '100000000000000000000',
        timestamp: new Date(Date.now() - 200000000).toISOString(),
      },
    ]
  },
  {
    id: '2',
    title: 'FTTF-2: Add New Content Category: Music',
    description: 'This proposal suggests adding a new content category specifically for music NFTs and streams, with specialized features for audio content. This will include waveform visualizations, music-specific metadata, and integration with popular music platforms.',
    summary: 'Add dedicated music category with specialized features',
    proposer: '0xabcdef123456789abcdef123456789abcdef1234',
    proposerName: 'MusicCreator',
    proposerAvatar: 'https://images.unsplash.com/photo-1570295999919-56ceb5ecca61?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1180&q=80',
    startBlock: 12345000,
    endBlock: 12445000,
    startTime: new Date(Date.now() - 1209600000).toISOString(),
    endTime: new Date(Date.now() - 604800000).toISOString(),
    status: 'executed',
    forVotes: '2500000000000000000000',
    againstVotes: '200000000000000000000',
    abstainVotes: '50000000000000000000',
    quorum: '2000000000000000000000',
    totalVotes: '2750000000000000000000',
    forPercentage: 90.9,
    againstPercentage: 7.3,
    abstainPercentage: 1.8,
    createdAt: new Date(Date.now() - 1209600000).toISOString(),
    executedAt: new Date(Date.now() - 604800000).toISOString(),
    category: 'Platform',
    tags: ['Music', 'Content', 'Features'],
    discussion: 'https://forum.fttf.world/t/proposal-add-new-content-category-music/456',
    actions: [
      {
        target: '0x609310f1014A6f3A26243C26B3027C86B7f5776f',
        value: '0',
        signature: 'addContentCategory(string)',
        calldata: '0x000000000000000000000000000000000000000000000000000000000000002000000000000000000000000000000000000000000000000000000000000000054d7573696300000000000000000000000000000000000000000000000000000000',
        description: 'Add Music category',
      },
    ],
    voters: [
      {
        address: '0x742d35Cc6634C0532925a3b844Bc454e4438f44e',
        name: 'DemoUser',
        vote: 'for',
        power: '500000000000000000000',
        timestamp: new Date(Date.now() - 1100000000).toISOString(),
      },
      {
        address: '0xabcdef123456789abcdef123456789abcdef1234',
        name: 'MusicCreator',
        vote: 'for',
        power: '2000000000000000000000',
        timestamp: new Date(Date.now() - 1000000000).toISOString(),
      },
      {
        address: '0x123456789abcdef123456789abcdef123456789a',
        name: 'NFTCollector',
        vote: 'against',
        power: '200000000000000000000',
        timestamp: new Date(Date.now() - 900000000).toISOString(),
      },
      {
        address: '0x987654321fedcba987654321fedcba987654321f',
        name: 'CryptoWhale',
        vote: 'abstain',
        power: '50000000000000000000',
        timestamp: new Date(Date.now() - 800000000).toISOString(),
      },
    ]
  },
  {
    id: '3',
    title: 'FTTF-3: Allocate Treasury Funds for Creator Grants',
    description: 'This proposal seeks to allocate 100,000 DUSD from the treasury to establish a Creator Grants Program. The program will provide financial support to promising creators on the platform, with a focus on innovative content and underrepresented voices.',
    summary: 'Allocate 100,000 DUSD for creator grants program',
    proposer: '0x123456789abcdef123456789abcdef123456789a',
    proposerName: 'NFTCollector',
    proposerAvatar: 'https://images.unsplash.com/photo-1527980965255-d3b416303d12?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1180&q=80',
    startBlock: 12445700,
    endBlock: 12545700,
    startTime: new Date(Date.now() - 172800000).toISOString(),
    endTime: new Date(Date.now() + 1209600000).toISOString(),
    status: 'active',
    forVotes: '1200000000000000000000',
    againstVotes: '800000000000000000000',
    abstainVotes: '300000000000000000000',
    quorum: '2000000000000000000000',
    totalVotes: '2300000000000000000000',
    forPercentage: 52.2,
    againstPercentage: 34.8,
    abstainPercentage: 13.0,
    createdAt: new Date(Date.now() - 172800000).toISOString(),
    category: 'Treasury',
    tags: ['Grants', 'Creators', 'Funding'],
    discussion: 'https://forum.fttf.world/t/proposal-allocate-treasury-funds-for-creator-grants/789',
    actions: [
      {
        target: '0xB0c23C31bF9e69A55ce705B46e098C1C402d247e',
        value: '0',
        signature: 'transferFunds(address,uint256)',
        calldata: '0x000000000000000000000000609310f1014A6f3A26243C26B3027C86B7f5776f00000000000000000000000000000000000000000000152d02c7e14af6800000',
        description: 'Transfer 100,000 DUSD to Grants Program contract',
      },
      {
        target: '0x609310f1014A6f3A26243C26B3027C86B7f5776f',
        value: '0',
        signature: 'initializeGrantsProgram()',
        calldata: '0x',
        description: 'Initialize the Grants Program',
      },
    ],
    voters: [
      {
        address: '0x742d35Cc6634C0532925a3b844Bc454e4438f44e',
        name: 'DemoUser',
        vote: 'for',
        power: '500000000000000000000',
        timestamp: new Date(Date.now() - 150000000).toISOString(),
      },
      {
        address: '0xabcdef123456789abcdef123456789abcdef1234',
        name: 'MusicCreator',
        vote: 'for',
        power: '700000000000000000000',
        timestamp: new Date(Date.now() - 140000000).toISOString(),
      },
      {
        address: '0x123456789abcdef123456789abcdef123456789a',
        name: 'NFTCollector',
        vote: 'against',
        power: '800000000000000000000',
        timestamp: new Date(Date.now() - 130000000).toISOString(),
      },
      {
        address: '0x987654321fedcba987654321fedcba987654321f',
        name: 'CryptoWhale',
        vote: 'abstain',
        power: '300000000000000000000',
        timestamp: new Date(Date.now() - 120000000).toISOString(),
      },
    ]
  },
  {
    id: '4',
    title: 'FTTF-4: Reduce Platform Fees to 1.5%',
    description: 'This proposal aims to reduce the platform fee from 2.5% to 1.5% to attract more users and increase overall transaction volume.',
    proposer: '0x123456789abcdef123456789abcdef123456789a',
    proposerName: 'CommunityMember',
    startBlock: 12340000,
    endBlock: 12440000,
    status: 'defeated',
    forVotes: '800000000000000000000',
    againstVotes: '1800000000000000000000',
    abstainVotes: '200000000000000000000',
    createdAt: new Date(Date.now() - 1814400000).toISOString(),
    actions: [
      {
        target: '0x609310f1014A6f3A26243C26B3027C86B7f5776f',
        value: '0',
        signature: 'setPlatformFee(uint256)',
        calldata: '0x000000000000000000000000000000000000000000000000000000000000000f',
        description: 'Set platform fee to 1.5%',
      },
    ],
  },
];

// Demo treasury data
export const demoTreasury = {
  address: '0xB0c23C31bF9e69A55ce705B46e098C1C402d247e',
  balance: '1250000',
  totalValueUSD: '1250000',
  treasuryGrowth: {
    daily: 2.3,
    weekly: 8.7,
    monthly: 24.5,
    yearly: 156.8
  },
  tokenBalances: [
    {
      token: 'DUSD',
      symbol: 'DUSD',
      balance: '750000',
      value: '750000',
      percentage: 60,
      logoUrl: 'https://cryptologos.cc/logos/multi-collateral-dai-dai-logo.png'
    },
    {
      token: 'USDC',
      symbol: 'USDC',
      balance: '250000',
      value: '250000',
      percentage: 20,
      logoUrl: 'https://cryptologos.cc/logos/usd-coin-usdc-logo.png'
    },
    {
      token: 'FTTF',
      symbol: 'FTTF',
      balance: '5000000',
      value: '250000',
      percentage: 20,
      logoUrl: 'https://cryptologos.cc/logos/ethereum-eth-logo.png'
    },
  ],
  recentTransactions: [
    {
      id: 'tx-1',
      hash: '0x123456789abcdef123456789abcdef123456789abcdef123456789abcdef1234',
      from: '0x18E5B223EfF55c1FbF1a31bC092ec688CE8ce9b7',
      to: '0xB0c23C31bF9e69A55ce705B46e098C1C402d247e',
      value: '5000.0',
      token: 'DUSD',
      tokenSymbol: 'DUSD',
      timestamp: new Date(Date.now() - 86400000).toISOString(),
      description: 'Platform fees collection',
      type: 'income',
      status: 'completed'
    },
    {
      id: 'tx-2',
      hash: '0xabcdef123456789abcdef123456789abcdef123456789abcdef123456789abcd',
      from: '0xB0c23C31bF9e69A55ce705B46e098C1C402d247e',
      to: '0x742d35Cc6634C0532925a3b844Bc454e4438f44e',
      value: '1.0',
      token: 'DUSD',
      timestamp: new Date(Date.now() - 172800000).toISOString(),
      description: 'Creator grant',
    },
  ],
};

// Demo analytics data
export const demoAnalytics = {
  totalUsers: 1245,
  totalCreators: 87,
  totalStreams: 156,
  totalNFTs: 423,
  totalVolume: '125.75',
  dailyActiveUsers: 78,
  weeklyActiveUsers: 312,
  monthlyActiveUsers: 845,
  revenueData: [
    { date: '2025-01-01', value: 1.2 },
    { date: '2025-01-02', value: 1.5 },
    { date: '2025-01-03', value: 1.3 },
    { date: '2025-01-04', value: 1.7 },
    { date: '2025-01-05', value: 2.1 },
    { date: '2025-01-06', value: 2.5 },
    { date: '2025-01-07', value: 2.2 },
    { date: '2025-01-08', value: 2.6 },
    { date: '2025-01-09', value: 3.0 },
    { date: '2025-01-10', value: 2.8 },
    { date: '2025-01-11', value: 3.2 },
    { date: '2025-01-12', value: 3.5 },
    { date: '2025-01-13', value: 3.7 },
    { date: '2025-01-14', value: 4.0 },
  ],
  userGrowthData: [
    { date: '2025-01-01', value: 850 },
    { date: '2025-01-02', value: 875 },
    { date: '2025-01-03', value: 890 },
    { date: '2025-01-04', value: 915 },
    { date: '2025-01-05', value: 950 },
    { date: '2025-01-06', value: 980 },
    { date: '2025-01-07', value: 1010 },
    { date: '2025-01-08', value: 1045 },
    { date: '2025-01-09', value: 1080 },
    { date: '2025-01-10', value: 1120 },
    { date: '2025-01-11', value: 1160 },
    { date: '2025-01-12', value: 1190 },
    { date: '2025-01-13', value: 1220 },
    { date: '2025-01-14', value: 1245 },
  ],
};